import React, { Fragment } from 'react';
import { PropTypes } from 'prop-types';
import { Field } from 'formik';
import DateInput from './controls/DateInput';

const Datepicker = ({ name, onChange, ...props }) => {
  return (
    <div className="datepicker-wrap">
      <Field
        name={name}
        render={({ field, form: { setFieldValue } }) => (
          <Fragment>
            <DateInput
              {...props}
              name={field.name}
              onChange={setFieldValue}
              value={field.value} />
          </Fragment>
        )}
      />
    </div>
  );
}

Datepicker.propTypes = {
  name: PropTypes.string.isRequired
};

export default Datepicker;



// WEBPACK FOOTER //
// ./src/components/form/Datepicker.js